import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { from, Observable, Subject } from 'rxjs';
import { ErrorMessages } from '../error-messages/error-messages';

@Injectable()
export class HelperService {
  errorCodes = ErrorMessages;

  //regx for passwor validation
  lowerCaseRegx = /^(?=.*[a-z])/;
  upperCaseRegx = /^(?=.*[A-Z])/;
  digitCaseRegx = /^(?=.*[0-9])/;
  specCharCaseRegx = /^(?=.*[!@?\-+:;\/\\,.#$&*])/;   //  /^(?=.*[!@#$%\\^&*+_.:;/])/;
  wholePasswordRegex = /^[A-Za-z0-9!@?\-+:;\/\\,.#$&*]*$/;
  redirectUrl = ''
  pageNotFoundSubs = new Subject();
  
  constructor(private _translate: TranslateService) {}

  moveToFirstErrorMessage() {
    setTimeout(() => {
      let errorFields = Array.from(document.querySelectorAll(".inputbox .error")).filter(s => s.closest(".inputbox").querySelectorAll(".optional-field:not([hidden])").length == 0);
      if (errorFields && errorFields.length > 0)
        window.scrollTo(0, errorFields[0].closest(".inputbox").getBoundingClientRect().top - document.body.getBoundingClientRect().top);
      else {
        let errorFields = Array.from(document.querySelectorAll(".document-error-div .error"));
        if (errorFields && errorFields.length > 0)
          window.scrollTo(0, errorFields[0].closest(".space-div").getBoundingClientRect().top - document.body.getBoundingClientRect().top);

      }
    }, 0);
  }

  /**
     * This is the checkErrorMessage function
     * @param error any
     * @returns string
   */
  checkErrorMessage(error: any): string {
    let message: string = '';
    if (error.hasOwnProperty('errorMessage') && error.errorMessage) {
      return this._translate.instant(error.errorMessage);
    }
    if (error.hasOwnProperty('statusText') && error.statusText) {
      return this._translate.instant(error.statusText);
    }
    if (this.errorCodes.hasOwnProperty(error)) {
      message = this._translate.instant(this.errorCodes[error]);
      if (this.isStringFound(message, '{{code}}')) {
        message = message.replace('{{code}}', error);
      }
      return message;
    }

    message = this._translate.instant(error);

    if (this.isStringFound(message, '{{code}}')) {
      message = message.replace('{{code}}', error);
    }

    return message;
  }

  /**
   * This is the isStringFound function
   * @param message string 
   * @param str string
   * @returns boolean
  */
  isStringFound(message: string, str: string) {
    return message.indexOf(str) != -1;
  }

  /**
   * This is the checkErrorMessage function
   * @param error string
   * @returns string
  */
  getErrorCodeMessage(code: string): string {
    return this._translate.instant(code);
  }

  addLeadingZeros(n) {
        if (n.length <= 5) {
            return this.addLeadingZeros("0" + n).toString();
        } else {
            return n.toString();
        }
    }

  goToOnlineBankingApp(){
    let tempurl = this.redirectUrl ? this.redirectUrl : 'http://onlinebanking.connectpay.com';
    window.open(tempurl, '_self'); 
  }
  goToForgotPasswordPage(){
    let tempurl = this.redirectUrl ? this.redirectUrl : 'http://onlinebanking.connectpay.com';
   
    window.open(tempurl+ '/forgetpassword', '_self'); 
  }

  goToSupportPage(){
    let tempurl = this.redirectUrl ? this.redirectUrl : 'https://connectpay.com/support/';
    window.open(tempurl, '_self');    
  }

  /**
   * This is the getCodeText function
   * @param code string
   * @returns string
   */
   getCodeText(code: string, params: any = null): string {
    return this._translate.instant(code, params);
  }

    /* This is the detectLocation function
* @param
* @returns Observable<any>
*/
public detectLocation(): Observable<any> {
  let abort : any  = AbortSignal;
  const apiCall = fetch("https://geolocation-db.com/json/", { signal: abort.timeout(2000) })
    .then(response => {
      return response.json();
    })
    .then(responseJson => {
      return responseJson as any
    })
    .catch((err) => {
      return err;
    })
  return from(apiCall)
}
}

